const rootActionPath = 'core/errorMessage';

export const ERROR_MESSAGE_FROM_SMARTY_SAVE = `${rootActionPath}/SAVE`;
